export const environment = {
    production: false,
    apiUrl: 'https://edge-api-v2-dev.nside.io'
};
  